/* eslint-disable complexity */

import React from 'react';
import PropTypes from 'prop-types'
import { get } from 'lodash/fp';
import ticketStatusConstants from '../../../utils/ticketStatusConstants.js';
import lookStatusConstants from '../../../utils/lookStatusConstants.js';
import VerificationBanner from '../../common/verificationBanner/VerificationBanner.js';
import ErrorBanner from '../../common/errorBanner/ErrorBanner.js';
import ClosedBanner from '../../common/closedBanner/ClosedBanner.js';
import ThankAlertModal from '../../modals/thankAlert/ThankAlertModal.js';
import PostRequestAlertModal from '../../modals/postRequestAlert/PostRequestAlertModal.js';
import TicketChangeModal from '../../modals/ticketChange/TicketChangeModal.js';
import TicketViewActions from '../../ticket/ticketViewActions/TicketViewActions.js';
import TicketViewContact from '../../ticket/ticketViewContact/TicketViewContact.js';
import TicketViewLocation from '../../ticket/ticketViewLocation/TicketViewLocation.js';
import TicketViewMap from '../../ticket/ticketViewMap/TicketViewMap.js';
import TicketViewSchedule from '../../ticket/ticketViewSchedule/TicketViewSchedule.js';
import LoadingBanner from '../../common/loadingBanner/LoadingBanner.js';
import ticketApproveByIdHoc from '../../hoc/ticketApproveByIdHoc.js';
import ticketLoadByIdHoc from '../../hoc/ticketLoadByIdHoc.js';

import './ticketViewPage.scss';

/**
 * The TicketViewPage component.
 *
 * @constructor
 */
export class TicketViewPage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);

    this.state = {
      postRequestModalActions: null,
      startModalActions: null,
      ticketChangeModalActions: null,
      thankModalActions: null,
      verificationActions: false,
    };

    this.onVerify = this.onVerify.bind(this);
  }

  /**
   * Fires when the component is about to be displayed on the page.
   */
  componentWillMount() {
    this.loadTicketInformation()
  }

  /**
   * Triggered when the component is about to receive new props.
   *
   * @param {{}} nextProps
   */
  componentWillReceiveProps(nextProps) {
    if (this.props.ticketLoadById.isLoading && !nextProps.ticketLoadById.isLoading) {
      this.triggerStartModal(nextProps.ticketLoadById.ticket);
    }

    if (this.props.ticketApproveById.isLoading && !nextProps.ticketApproveById.isLoading) {
      if (this.state.thankModalActions) {
        this.state.thankModalActions.show();
      }

      this.loadTicketInformation();
    }
  }
  onVerify() {
    this.setState({
      verificationActions: true
    });
    this.loadTicketInformation()
  }

  /**
   * Accepts the ticket as valid.
   */
  approveTicket = () => {
    const locationProps = this.props.location;
    const ticketId = (locationProps && locationProps.query) ? locationProps.query.tid : null;
    if (ticketId) {
      this.props.ticketApproveById.approveTicket(ticketId);
    }
  };

  /**
   * Activates the request change form.
   */
  requestChange = () => {
    if (this.state.ticketChangeModalActions) {
      this.state.ticketChangeModalActions.show();
    }
  };

  /**
   * Triggered when the change request modal is closed.
   *
   * @param {boolean} hadChanges Whether or not there were changes.
   */
  onChangeRequestClose = (hadChanges) => {
    if (!hadChanges) {
      return;
    }

    if (this.state.postRequestModalActions) {
      this.state.postRequestModalActions.show();
    }

    this.loadTicketInformation();
  };

  /**
   * Loads the ticket information from the server.
   */

  loadTicketInformation = () => {
    const locationProps = this.props.location;
    const ticketId = (locationProps && locationProps.query) ? locationProps.query.tid : null;
    const isCredentials = sessionStorage.getItem('credentials');

    if (ticketId && isCredentials) {
      this.setState({
        verificationActions: true
      });

      this.props.ticketLoadById.verifyAndGetTicket(ticketId)
    } else if (ticketId && this.state.verificationActions) {
      this.props.ticketLoadById.getTicket(ticketId);
    }
  };

  /**
   * Registers the thank you modal actions.
   *
   * @param {string} modalType
   * @param {{open: function, close: function, toggle: function}} actions
   */
  registerModalActions = (modalType, actions) => {
    const stateName = `${modalType}ModalActions`;

    this.setState({
      [stateName]: actions
    })
  };

  /**
   * Opens the starting modal if the ticket if awaiting a review.
   *
   * @param {{processStatus: string}} ticket
   */
  triggerStartModal = (ticket) => {
    if (!this.state.startModalActions || !ticket) {
      return;
    } else if (ticket.processStatus !== ticketStatusConstants.awaitingReview) {
      return;
    }

    this.state.startModalActions.show();
  };

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const noTicketStatus = 404;
    const locationProps = this.props.location;
    const ticketId = (locationProps && locationProps.query) ? locationProps.query.tid : null;

    const ticketIsLoading = this.props.ticketLoadById.isLoading || false;
    const error = this.props.ticketLoadById.error || null;
    const noScrollTimeout = 2000;

    if (!ticketIsLoading) {
      setTimeout(() => {
        document.querySelector('.topbar').classList.remove('loading');
        document.querySelector('.logo').classList.remove('loading');
        document.querySelector('body').classList.remove('noScroll');
      }, noScrollTimeout);
    }

    let ticket = this.props.ticketLoadById.ticket || null;
    if (ticket && !ticket.look) {
      ticket = null;
    }
    const processingRequest = this.props.ticketApproveById.isLoading || false;
    return (

      <div id="ticket-view-page" className="system-page ticket-view-page">
        {(ticketIsLoading && this.state.verificationActions) && (
          <LoadingBanner/>
        )}
        {(this.props.invalidVerification) && (
          <VerificationBanner action={this.onVerify} />
        )}
        {(!ticketIsLoading && ticket === null && error === null && !this.state.verificationActions) && (
          <VerificationBanner action={this.onVerify}
          />
        )}
        {(!ticketIsLoading && error && !error.response && error !== null) && (
          <ErrorBanner />
        )}

        {(!ticketIsLoading && error && error !== null && error.response && error.response.status !== noTicketStatus) && (
          <ErrorBanner />
        )}

        {(!ticketIsLoading && error !== null && !error && !ticket) && (
          <ErrorBanner />
        )}

        {(!ticketIsLoading && !ticket && error && (error.response && error.response.status === noTicketStatus)) && (
          <ClosedBanner />
        )}

        {(!ticketIsLoading && !error && ticket &&
          (get('status', ticket) === ticketStatusConstants.closed ||
            (get('look.status', ticket) !== lookStatusConstants.unassigned &&
              get('look.status', ticket) !== lookStatusConstants.assigned &&
              get('look.status', ticket) !== lookStatusConstants.soliciting)))
          && (
            <ClosedBanner />
          )}

        {(get('look.status', ticket) !== lookStatusConstants.canceled && !ticketIsLoading && !error && ticket &&
          (get('status', ticket) !== ticketStatusConstants.closed ||
            get('look.status', ticket) === lookStatusConstants.unassigned ||
            get('look.status', ticket) === lookStatusConstants.assigned)) && (
            <div className="content">
              <div className="wgl-line-item">
                <p>Welcome!</p>
                <p>
                  <strong>{ticket.look.requester}</strong> has requested WeGoLook to perform the following service:
                </p>
                <p>{ticket.look.jobName}</p>
                <p><strong>Please verify that the information below is correct:</strong></p>
              </div>

              <div className="wgl-line-item contact-item">
                <TicketViewContact contact={ticket.look.contact || {}} />
              </div>

              <div className="wgl-line-item location-item">
                <TicketViewLocation location={ticket.look.location || {}} />
              </div>

              <TicketViewMap location={ticket.look.location || {}} />

              <div className="wgl-line-item schedule-item">
                <TicketViewSchedule scheduledTime={ticket.look.scheduledTime} />
              </div>

              {(ticket.look.assetDetails) && (
                <div className="wgl-line-item asset-details">
                  <div className="look-details-item">
                    <h3>{ticket.look.assetDetails.heading}</h3>
                    <ul>{ticket.look.assetDetails.fields.map((fld, i) => {
                      return <li key={i}>{fld.subHeading}: <strong>{fld.value}</strong> </li>;
                    })}
                    </ul>
                  </div>
                </div>
              )}

              <div className="wgl-line-item wgl-line-item--highlight update-item">
                <TicketViewActions
                  processingRequest={processingRequest}
                  processStatus={ticket.processStatus || get('look.verification.status', ticket)}
                  approveTicket={this.approveTicket}
                  requestChange={this.requestChange}
                />
              </div>

              <TicketChangeModal
                registerModalActions={this.registerModalActions.bind(this, 'ticketChange')}
                ticketId={ticketId}
                onClose={this.onChangeRequestClose}
              />

              {(ticket.look.looker) && (
                <div>
                  <div className="wgl-line-item looker-item">
                    <p>Your Looker is <strong>{ticket.look.looker}</strong></p>
                  </div>

                </div>
              )}

              {(ticket.look.lookDetails) && (
                <div>
                  <div className="wgl-line-item look-details-item">
                    <h3>Look Details</h3>
                    <p>{ticket.look.lookDetails}</p>
                  </div>

                </div>
              )}

              {(ticket.look.requester) && (
                <div>
                  <div className="wgl-line-item requester-item">
                    <h3 className="requested-header">Requested on behalf of</h3>
                    <p><strong className="requesting-client">{ticket.look.requester}</strong></p>
                  </div>

                </div>
              )}

              <div className="wgl-line-item help-item">
                <div>Contact WeGoLook with any questions:</div>
                <div>
                  <span className="inline-text">Reference Look # </span>
                  <strong className="inline-text">{ticket.look.jobNumber}</strong>
                </div>
                <div>+1 (855) 947-1788</div>
                <div><a href="mailto:support@wegolook.com">WeGoLook Support</a></div>
              </div>

            </div>
          )}

        <PostRequestAlertModal
          registerModalActions={this.registerModalActions.bind(this, 'postRequest')}
        />
        <ThankAlertModal
          registerModalActions={this.registerModalActions.bind(this, 'thank')}
        />

      </div>

    );
  }
}

TicketViewPage.propTypes = {
  // React Router location data.
  location: PropTypes.shape({
    query: PropTypes.shape({
      tid: PropTypes.string,
    }),
  }).isRequired,

  // TicketApproveById HOC
  ticketApproveById: PropTypes.shape({
    approveTicket: PropTypes.func,
    isLoading: PropTypes.bool,
    success: PropTypes.bool,
    error: PropTypes.object,
  }),

  // TicketLoadById HOC
  ticketLoadById: PropTypes.shape({
    verifyAndGetTicket: PropTypes.func,
    getTicket: PropTypes.func,
    isLoading: PropTypes.bool,
    ticket: PropTypes.object,
    error: PropTypes.object,
  }),
  invalidVerification: PropTypes.bool
};

export default ticketApproveByIdHoc(
  ticketLoadByIdHoc(
    TicketViewPage
  )
);



// WEBPACK FOOTER //
// ./src/components/pages/ticketView/TicketViewPage.js